import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .ISTimeLine': {
    padding: 0,
  },
  '& .ISTimeIItem': {
    minHeight: theme.spacing(3),
    '&:before': {
      flex: 0,
      padding: 0,
    },
  },
  '& .ISTimelineContent': {
    marginTop: theme.spacing(1),
    maxWidth: theme.spacing(85),
    width: '100%',
  },
  '& .ISTimelineConnector': {
    backgroundColor: theme.palette.divider[7],
    width: theme.typography.pxToRem(1),
    '&.ISEmptyConnector': {
      marginLeft: theme.typography.pxToRem(8),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.typography.pxToRem(4),
      },
    },
  },
  '& .ISTimelineDot': {
    borderWidth: theme.typography.pxToRem(3),
    padding: theme.typography.pxToRem(5),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      borderWidth: theme.typography.pxToRem(2),
      padding: theme.typography.pxToRem(2),
    },
  },
}));

export default StyledBox;
